import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Panel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: ${({ theme }) => theme.width};
  padding: ${({ theme }) => theme.padding};
  gap: 12px;

  background: ${({ theme }) => theme.background};
  border-radius: ${themeStyle.radiusLarge};

  a,
  span {
    text-decoration-line: underline;
    cursor: pointer;
  }
`;
